export interface AddressLookupProps {
  id: string,
  state?: AddressLookupState,
  switchToManual: () => void,
  lookupFailureHandler: () => void,
  className?: string,
  takeFocus?: boolean
}

export interface AddressLookupSuggestion {
  singleLine:string,
  dpid:string
}

export interface AddressLookupState {
  searchTerm?: string,
  suggestions?: AddressLookupSuggestion[],
  selectedValue?: AddressLookupSuggestion,
  selectedAddressDetail?: any,
  suggestionsVisible?: boolean,
  error?: string,
  takeFocus?: boolean
}

export type SupportedAddressTypes = 'THOROUGHFARE' | 'POSTAL';
export type SupportedAddressDeliveryPointCategories =
  | 'BUSINESS'
  | 'RESIDENTIAL'
  | 'MIXED';

export type AddressApiRequest = {
  id: string;
  maxResults: number; // should be <= 20
  predictive: boolean;
  matchBuildingAliases: boolean;
  fallbackToFuzzySearch: boolean;
  addresses: {
    id: string;
    text: string;
  }[];
  detail?: {
    singleLine: boolean;
    semiStructured: boolean;
    structured: boolean;
    upu: boolean;
    geo: boolean;
    delivery: boolean;
  };
  filters?: {
    addressType: SupportedAddressTypes | null;
    phantom?: boolean;
    deliveryPointCategories?: SupportedAddressDeliveryPointCategories[] | null;
  };
};


type AddressLookupSuggestionWithMatch = AddressLookupSuggestion & { matches: (candidate) => boolean };

const manualAddressItemText = 'Please click here to enter a manual address';
export const MANUAL_ADDRESS_SUGGESTION: AddressLookupSuggestionWithMatch = {
  singleLine: manualAddressItemText,
  dpid: 'manual',
  matches: (candidate) => candidate && candidate ? manualAddressItemText === candidate.trim() : false
}
